import { render, staticRenderFns } from "./QuestionBlock.vue?vue&type=template&id=c8f2fb70&scoped=true&"
import script from "./QuestionBlock.vue?vue&type=script&lang=js&"
export * from "./QuestionBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f2fb70",
  null
  
)

export default component.exports